import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedomaLogoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 384 384",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M230.5 0L195.452 35.0605L334.426 174.07V383.865H384V153.54L230.5 0Z",
		fill: "black"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M164.154 105.154H114.58V219.775H0V269.366H114.58V384H164.154V269.366H278.748V219.775H164.154V105.154Z",
		fill: "black"
	})]
});
export default SvgMedomaLogoIcon;
